// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "build/css/" + chunkId + "." + {"44":"06342848","105":"0ab1271d","368":"799e9a1f","407":"6665e6c4","869":"358537bd","958":"722e44d1"}[chunkId] + ".css";
};